import React from "react";
import UrBox from "../../assets/fontawesome/image/logo_mvc.png";
export default function FooterLogo() {
  return (
    <div className="fixed z-50 bottom-0 h-5 w-full flex justify-center items-center bg-[#ECF3FF]">
      <div className="flex w-[74px]">
        <img src={UrBox} className="w-[54px] " />
      </div>
      {/* <div className="ml-4 text-[9px] font-regular">|</div> */}
      <div className="ml-1 text-[11px] font-regular">
        © 2026 Powered by <span className="font-bold"> MVC Tech</span>
      </div>
    </div>
  );
}
